module.exports = __webpack_public_path__ + "media/images/noticia04-2-ec303f90e3c8283809c7c59b1ee4cdc9.jpeg";